import echarts from "echarts";
import merge from "lodash/merge";
let setAdaption = function (size, setPro) {
  if (!setPro) {
    // 默认值
    return 10 * size;
  }
  return setPro * size;
};
let chart = null;
export const linebarOption = (setPro, element_id, data) => {
  if (chart === null) {
    chart = echarts.init(document.getElementById(element_id));
    chart.timer = null;
  }
  const seriesData =
    data &&
    data.seriesData.map((v) => {
      return {
        name: v.name,
        // itemStyle: {
        //   normal: {
        //     color: v.barcolor,
        //   },
        // },
        lineStyle: {
          //折线颜色
          normal: {
            width: setAdaption(0.1, setPro),
            color: v.linecolor,
          },
        },
        itemStyle: {
          //图例、拐点
          color: v.linecolor,
        },
        data: v.data,
      };
    });
  const myOption = {
    series: seriesData,
    xAxis: data && { data: data.xAxisData },
  };
  let option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      position: function(pt, params, dom, rect, size) {
        if(parseFloat(size.viewSize) - parseFloat(pt[0])<= parseFloat(size.contentSize)){
          return [parseFloat(pt[0])-parseFloat(size.contentSize), '30%'];
        }
        return [pt[0], '30%'];
      },
      formatter: function (params) {
        var str = ""; //声明一个变量用来存储数据
        str = params[0].name + "</br>";
        //图显示的数据较多时需要循环数据，这样才可以成功的给多条数据添加单位
        for (var i = 0; i < params.length - 1; i++) {
          // if (params[i].data === 0) {
          //   params[i].data = '0';
          // }
          str +=
            `<span style="display:inline-block;width:10px;height:10px;background-color:` +
            params[i].color +
            `;margin-right:3px"></span>
          <span style="display:inline-block;">` +
            params[i].seriesName +
            " : " +
            `</span>` +
            "&nbsp" +
            `<span>` +
            params[i].data +
            "%" +
            `<span>` +
            "</br>";
        }
        return str;
      },
      textStyle: {
        color: "rgba(255, 255, 255, 1)",
        fontSize: setAdaption(0.65, setPro),
        lineHeight: setAdaption(1, setPro),
      },
    },
    grid: {
      left: "7%",
      top: "12%",
      right: "7%",
      bottom: "22%",
    },
    legend: [
      {
        top: "3%",
        left: "center",
        data: ["信用扣分任务量占比", "前一年同比数据"],
        icon: "rect",
        selectedMode: false,
        itemWidth: 10,
        itemHeight: 10,
        textStyle: {
          fontSize: setAdaption(0.6, setPro),
          color: "rgba(255, 255, 255, 0.65)",
          padding: [3, 20, 0, 0],
        },
      },
      {
        top: "3%",
        right: "16%",
        data: ["信用扣分率趋势"],
        icon: "roundRect",
        selectedMode: false,
        itemWidth: 13,
        itemHeight: 3,
        textStyle: {
          fontSize: setAdaption(0.6, setPro),
          color: "rgba(255, 255, 255, 0.65)",
          padding: [3, 20, 0, 0],
        },
      },
    ],
    xAxis: {
      data: [],
      //x轴线
      axisLine: {
        show: true,
        lineStyle: {
          color: "rgba(255, 255, 255, 0.16)",
          opacity: 1,
          width: setAdaption(0.1, setPro),
          type: "solid",
        },
      },
      axisTick: {
        show: false, //隐藏X轴刻度
      },
      axisLabel: {
        textStyle: {
          color: "rgba(255, 255, 255, 1)",
          fontSize: setAdaption(0.6, setPro),
        },
      },
    },
    yAxis: [
      {
        type: "value",
        min: 0,
        name: "%",
        nameTextStyle: {
          color: "rgba(255, 255, 255, 1)",
          fontSize: setAdaption(0.6, setPro),
          padding: [0, 0, 0, -26],
        },
        //轴线
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "rgba(255, 255, 255, 0.16)",
            type: "dotted",
          },
        },
        axisLabel: {
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            fontStyle: "normal",
            fontSize: setAdaption(0.6, setPro),
          },
        },
      },
      {
        type: "value",
        min: 0,
        // max: 120,
        // minInterval: 25,
        // splitNumber: 5,
        name: "%",
        nameTextStyle: {
          color: "rgba(255, 255, 255, 1)",
          fontSize: setAdaption(0.6, setPro),
          padding: [0, -16, 0, 0],
        },
        //轴线
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "rgba(255, 255, 255, 0.16)",
            type: "dotted",
          },
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
            fontStyle: "normal",
          },
        },
      },
    ],
    series: [
      {
        name: "信用扣分任务量占比",
        type: "bar",
        barGap: "10%", //双柱间距离
        barWidth: setAdaption(1, setPro),
        itemStyle: {
          normal: {
            color: "rgba(24, 144, 255, 1)",
          },
        },
        data: [],
      },
      {
        name: "前一年同比数据",
        type: "bar",
        barWidth: setAdaption(1, setPro),
        itemStyle: {
          normal: {
            color: "rgba(69, 218, 209, 1)",
          },
        },
        data: [],
      },
      {
        name: "信用扣分率趋势",
        type: "line",
        yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
        showAllSymbol: true, //显示所有图形。
        symbol: "circle", //标记的图形为实心圆
        symbolSize: 6, //标记的大小
        itemStyle: {
          //折线拐点标志的样式
          color: "rgba(255, 169, 64, 1)",
          borderColor: "rgba(255, 169, 64, 1)",
          width: 2,
        },
        lineStyle: {
          color: "rgba(255, 169, 64, 1)",
          width: 2,
          shadowBlur: 2,
        },
        //鼠标经过时拐点样式
        emphasis: {
          itemStyle: {
            borderWidth: 2,
            borderColor: "rgba(255, 169, 64, 1)",
            //拐点颜色
            color: "#fff",
          },
        },
        data: [],
      },
    ],
  };
  const finalSeries = merge(option, myOption);
  chart.setOption(finalSeries);
  
  let index = 0,
  data_len = option.series[0].data.length,
  paly_index = [];

  // 处理数据：series[0]和series[1]中的数据均为空时不轮播该组数据
  // 将可播放数据的索引存储在paly_index中
  for(let i=0; i<data_len; i++) {
    if(option.series[0].data[i] || option.series[1].data[i]){
      paly_index.push(i)
    }
  }

  // 鼠标悬浮到某条数据时，获取其在play_inde中的索引
  function indexOf(value) {
    for(let j=0; j<paly_index.length; j++){
      if(value === paly_index[j]){
        return j
      }
    }
    return -1
  }
  // 设置toolTip轮播效果
  function autoTip() {
    clearInterval(chart.timer)
    chart.timer = setInterval(() => {
        chart.dispatchAction({
            type: 'showTip',
            seriesIndex: option.series[0].data[paly_index[index]] === 0 ? 1 : 0,
            dataIndex: paly_index[index]
        });
        index++;
        if (index >= paly_index.length) {
            index = 0
        }
    }, 3000)
    chart.on('mousemove', function(e){
      clearInterval(chart.timer)
      chart.dispatchAction({
          type: 'hideTip',
          seriesIndex: 0,
          dataIndex: paly_index[index-1]
      });
      chart.dispatchAction({
          type: 'showTip',
          seriesIndex: option.series[0].data[paly_index[index]] === 0 ? 1 : 0,
          dataIndex: e.dataIndex
      })
    })
    chart.on('mouseout', function(e){
      clearInterval(chart.timer)
      chart.dispatchAction({
          type: 'hideTip',
          seriesIndex: 0,
          dataIndex: e.dataIndex
      });
      index = indexOf(e.dataIndex) + 1;
      chart.timer = setInterval(() => {
          chart.dispatchAction({
            type: 'showTip',
            seriesIndex: option.series[0].data[paly_index[index]] === 0 ? 1 : 0,
            dataIndex: paly_index[index]
          });
          index++;
          if (index >= paly_index.length) {
              index = 0;
          }
      }, 3000)
    })
  }
  autoTip();
  return chart;
};
